import React from 'react';

const GalleryCard = ({ image, title, device, onPlay }) => {

   

  const deviceStyles = {
    mobile: { width: '100%',  
      flexWrap: 'wrap',
      flexShrink: 0, /* shrink-0 */
      padding: '1rem', /* p-4 (16px) */
      position: 'relative', /* relative */
      borderRadius: '20px', /* rounded-[20px] */
      overflow: 'hidden', /* overflow-hidden */
      aspectRatio: 'auto', /* aspect-video */
      boxSizing: 'border-box', /* container (tailwind container handles padding/margin also) */ },
 
    tablet: { width: "50%",
       flexWrap: 'wrap',
      flexShrink: 0, /* shrink-0 */
      padding: '1rem', /* p-4 (16px) */
      position: 'relative', /* relative */
      borderRadius: '20px', /* rounded-[20px] */
      overflow: 'hidden', /* overflow-hidden */
      aspectRatio: 'auto', /* aspect-video */
      boxSizing: 'border-box', /* container (tailwind container handles padding/margin also) */ },
    desktop: { width: '25%', /* w-1/4 */
      flexWrap: 'wrap',
      flexShrink: 0, /* shrink-0 */
      padding: '1rem', /* p-4 (16px) */
      position: 'relative', /* relative */
      borderRadius: '20px', /* rounded-[20px] */
      overflow: 'hidden', /* overflow-hidden */
      aspectRatio: 'auto', /* aspect-video */
      boxSizing: 'border-box', /* container (tailwind container handles padding/margin also) */ },
  };

  const linkStyle = {
    position: 'relative',
    width: deviceStyles[device].width,
    height: deviceStyles[device].height,
    minHeight: '520px',
    maxHeight: '613px',
    maxWidth: '100%',
    margin: 'auto',
  
    boxSizing: 'border-box',
    borderRadius: '15px',
    background: '#1a1a1a',
    border: '1px solid #161616',
    transition: 'all 0.3s ease-in-out',
  };
  //console.log("DEVICE ==== ",device)

  return (
    <div 
 style={{
    backgroundImage: `url(${image})`,
    backgroundSize: 'cover',
    backgroundPosition: '50% 50%',
    ...deviceStyles[device],
  }}>
        <div className="absolute left-0 right-0 bottom-0 px-4 py-2 h-[200px] flex flex-col justify-end ">
   <div className="w-full text-xs text-white text-left">{title}</div>
   <div className="w-full text-xs theme-link flex items-center  cursor-pointer" onClick={onPlay}>
     <div className="mr-2">
       <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="play" className="svg-inline--fa fa-play " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
         <path fill="currentColor" d="M73 39c-14.8-9.1-33.4-9.4-48.5-.9S0 62.6 0 80L0 432c0 17.4 9.4 33.4 24.5 41.9s33.7 8.1 48.5-.9L361 297c14.3-8.7 23-24.2 23-41s-8.7-32.2-23-41L73 39z"></path>
       </svg>
     </div>
     <div>PLAY FILM</div>
   </div>
   <div className="h-3"></div>
 </div>
 <div id="videoIconParent" className="absolute top-0 right-0 left-0 bottom-0 flex items-center justify-center">
   <div id="videoIcon" className="text-4xl text-white opacity-60 center-play-ico">
     <img alt="play" loading="lazy" className='w-10 h-10'  src="../../../img/video_icon.svg" />
   </div>
 </div>

</div>
  );
};

export default GalleryCard;
